import { Box } from "@mui/material";

import { useNextSanityImage } from "next-sanity-image";

import dynamic from "next/dynamic";

import React from "react";

import { SanityClientLike } from "@sanity/image-url/lib/types/types";

import sanityClient from "../../../lib/sanityClient";

const NextImage = dynamic(() => import("next/image"));

type Props = {
    value: {
        alt: string;
    };
    sx?: Record<string, unknown>;
};
const SanityImage = ({ value, sx = {} }: Props) => {
    const imageProps = useNextSanityImage(
        sanityClient as unknown as SanityClientLike,
        value
    );

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height: "400px",
                my: 2,
                mb: 4,
                ...sx
            }}
        >
            <NextImage
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...imageProps}
                alt={value.alt}
                fill
                width={undefined} // remove the width and height props to make it responsive
                height={undefined} // remove the width and height props to make it responsive
                sizes="100vw"
                style={{
                    objectFit: "contain"
                }}
            />
        </Box>
    );
};

export default SanityImage;
